//
// USER
//
export const UPDATE_USER = 'UPDATE_USER'

export const DELETE_USER = 'DELETE_USER'


//
// DASHBOARD
//
export const UPDATE_BOOKINGS = 'UPDATE_BOOKINGS'

export const ADD_RESERVATION = 'ADD_RESERVATION'

export const ADD_UNIT = 'ADD_UNIT'

export const ADD_LOCATION = 'ADD_LOCATION'

export const ADD_PROTECTION = 'ADD_PROTECTION'


//
// PAYMENT
//
export const RESET_PAYMENT = 'RESET_PAYMENT'

export const SET_PAYMENT_PAGE_INDEX = 'SET_PAYMENT_PAGE_INDEX'

export const ADD_PAYMENT_PAGE = 'ADD_PAYMENT_PAGE'

export const SET_PAYMENT_LOCATION = 'SET_PAYMENT_LOCATION'

export const SET_PAYMENT_RESERVATION = 'SET_PAYMENT_RESERVATION'

export const SET_PAYMENT_MOVEIN = 'SET_PAYMENT_MOVEIN'

export const SET_PAYMENT_DISCOUNT = 'SET_PAYMENT_DISCOUNT'

export const SET_PAYMENT_DISCOUNT_ID = 'SET_PAYMENT_DISCOUNT_ID'

export const SET_PAYMENT_DIRECT_BOOKING = 'SET_PAYMENT_DIRECT_BOOKING'

export const SET_PAYMENT_UNIT_SELECTION = 'SET_PAYMENT_UNIT_SELECTION'

export const ADD_PAYMENT_UNIT_INFO = 'ADD_PAYMENT_UNIT_INFO'

export const SET_PAYMENT_CARD_INFO = 'SET_PAYMENT_CARD_INFO'

export const SET_PAYMENT_ENCRYPTED_CARD_INFO = 'SET_PAYMENT_ENCRYPTED_CARD_INFO'

export const SET_PAYMENT_SIZE_SUGGESTIONS = 'SET_PAYMENT_SIZE_SUGGESTIONS'

export const SET_PAYMENT_AMENITY_SUGGESTIONS = 'SET_PAYMENT_AMENITY_SUGGESTIONS'

export const ADD_PAYMENT_RETAIL = 'ADD_PAYMENT_RETAIL'

export const CLEAR_PAYMENT_RETAIL = 'CLEAR_PAYMENT_RETAIL'

export const SET_PAYMENT_RETAIL = 'SET_PAYMENT_RETAIL'

export const SET_PAYMENT_RETAIL_OVERRIDE = 'SET_PAYMENT_RETAIL_OVERRIDE'

export const ADD_PAYMENT_INSURANCE = 'ADD_PAYMENT_INSURANCE'

export const CLEAR_PAYMENT_INSURANCE = 'CLEAR_PAYMENT_INSURANCE'

export const SET_PAYMENT_INSURANCE = 'SET_PAYMENT_INSURANCE'


//
// META
//
export const SET_POPUP_RECORD = 'SET_POPUP_RECORD'

export const SET_ADMIN_LOCATION = 'SET_ADMIN_LOCATION'
